import React from 'react'
import { Flex } from '@chakra-ui/react'
import type { ObjectOfBandwidthUrlAndViews } from '../../interfaces'
import AnalyticsFileElement from './AnalyticsFileElement'

interface Props {
  data: ObjectOfBandwidthUrlAndViews[] | undefined
  showPreview: boolean
  forceimagePreview: boolean
}

const ImageGrid = ({ data, showPreview, forceimagePreview }: Props): React.ReactElement => {
  const filesList = data ?? []

  return (
    <Flex
      width="100%"
      wrap="wrap"
      justifyContent="space-between"
      _after={{ content: '""', flex: 'auto' }}
    >
      {filesList.map(x => (
        <AnalyticsFileElement
          key={x.url}
          bandwidth={x.bandwidth}
          url={x.url}
          views={x.views}
          showPreview={showPreview}
          forceimagePreview={forceimagePreview}
        />
      ))}
    </Flex>
  )
}

export default ImageGrid
